import { useMutation, useQueryClient } from "react-query";
import { mssaemAxios as axios } from "../../apis/axios";
import { worryKeys } from "../../constants/matchingKey";

async function deleteBoard(id: number): Promise<void> {
  await axios.delete(`/member/worry-board/${id}`);
}

interface UseDeleteBoard {
  mutate: () => void;
}

export function useDeleteBoard(id: number): UseDeleteBoard {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(() => deleteBoard(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(worryKeys.all);
    },
  });
  return { mutate };
}